import axios from "axios";
// Create an Axios instance with default configurations
const axiosInstance = axios?.create({
  baseURL:
    globalThis.location?.host === "localhost:3000"
      ? "http://localhost:5000/api"
      : "/api", // Replace with your API URL

  withCredentials: true, // Set this to true to include credentials
});
axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    const isInvalidSession =
      err.response?.status === 401 ||
      err.response?.data?.msg === "Token is not valid" ||
      err.response?.data?.error === "Not authenticated";
    if (isInvalidSession) {
      setAuthToken(null);
    }
    return Promise.reject(err);
  }
);
export const setAuthToken = (token?: string | null) => {
  if (token) {
    axiosInstance.defaults.headers.common["Authorization"] = token;

    localStorage.setItem("token", token);
  } else {
    delete axiosInstance.defaults.headers.common["Authorization"];
    localStorage.removeItem("token");
  }
};

export default axiosInstance;
